import { useIntl } from 'react-intl'
import { NavigationItem, Number } from 'components/global/Header/styles'
import Text from 'components/shared/Text'
import Icon from 'components/shared/Icon'
import {
    CreatorAccommodationStep,
    SelfcareStep,
    UnlimitedCardStep,
    UnlimitedRenewStep,
    VouchersStep,
} from 'store/general-slice/types'

type DesktopNavigationContentProps = {
    isActive: boolean
    isCompleted: boolean
    navigationIndex: number
    title: { id: string; defaultMessage: string }
    onClick?: () => void
    id:
        | SelfcareStep
        | UnlimitedCardStep
        | UnlimitedRenewStep
        | VouchersStep
        | CreatorAccommodationStep
}

export const DesktopNavigationContent = ({
    isActive,
    isCompleted,
    navigationIndex,
    title,
    onClick,
    id,
}: DesktopNavigationContentProps) => {
    const { formatMessage } = useIntl()

    return (
        <NavigationItem
            isCompleted={isCompleted}
            direction="row"
            gap={12}
            onClick={onClick}
            align="flex-end"
            data-testid={`step-navigation-${id}`}
        >
            <Number isActive={isActive} isCompleted={isCompleted}>
                <Text variant="bodyExtraSmall" color="grayscale_100">
                    {isCompleted ? (
                        <Icon variant="checkmark" size={14} />
                    ) : (
                        navigationIndex
                    )}
                </Text>
            </Number>
            <Text
                variant="heading5"
                color={
                    isActive || isCompleted ? 'grayscale_900' : 'grayscale_700'
                }
                hasTransition
            >
                {formatMessage(title)}
            </Text>
        </NavigationItem>
    )
}
